import React, { Component } from 'react'
import { AUTH_API_URL, CS_API_URL, FB_API_URL, parseJwt } from '../lib/env'
import axios from 'axios'
import {
  Paper,
  Chip,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Snackbar,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField
} from '@material-ui/core'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import DeleteIcon from '@material-ui/icons/Delete'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import DoneIcon from '@material-ui/icons/Done'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import moment from 'moment'
import { getCityNameByCode } from '../lib/util'
import CloseIcon from '@material-ui/icons/Close'
import Tooltip from '@material-ui/core/Tooltip'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import ViewCreditRequest from './view_credit_request'
import { CreditRequestButton } from '../components/credit_request_button'
import Slide from '@material-ui/core/Slide'
import EditIcon from '@material-ui/icons/Edit'
import RefreshIcon from '@material-ui/icons/Refresh'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import EditCreditRequest from './edit_credit_request'
import { PhotoCamera } from '@material-ui/icons'
import PhotoModal from '../components/PhotoModal'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'
import Axios from 'axios'

class CreditRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      seoNumber: '',
      token: localStorage.getItem('token'),
      isLoading: false,
      isSendLoading: false,
      countFilterRequests: 0,
      filterAllRequests: 0,
      currentPage: 0,
      rowsPerPage: 10,
      clientIIN: '',
      filterStartDate: moment(new Date()).subtract(1, 'week').toDate(),
      filterEndDate: new Date(),
      isInfoDialogOpen: false,
      isKMFDialogOpen: false,
      isEurasianDialogOpen: false,
      isTfsDialogOpen: false,
      isFreedomDialogOpen: false,
      isForteDialogOpen: false,
      isMogoDialogOpen: false,
      eurasianBankProductCode: '',
      tfsProductCode: '',
      eurasianBankInsuranceDuration: null,
      selectedCreditRequest: null,
      currentProducts: [],
      selectedProduct: '',
      selectedBank: '',
      snackbarOpen: false,
      isRefreshIconDisabled: false,
      selectedBranch: '',
      isSendingToEurasianBank: false,
      isSendingToTfs: false,
      isSendingToFreedom: false,
      isSendingToForte: false,
      isSendingToKMF: false,
      isSendingToMogo: false,
      isProcessCreditRequestOpen: false,
      crView: false,
      crEdit: false,
      openPhoto: false,
      error: false,
      clientOtpCode: '',
      isOtpDialogOpen: false,

      NsCompanyCode: '',
      IsInsuranceInside: false,
      KaskoProductCode: '',

      mogoSendButtonEnabled: true,
      alternativeComment: null,
      sendCreditRequestPageNumber: 0,

      halykCreditType: 'standard',

      sendAllFinOrgsButtonEnabled: true,
      isSendingToAllFinOrgs: false,
      openSendAllDialog: false
    }

    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
  }

  handleCloseSnackbar() {
    this.setState({
      snackbarOpen: false
    })
  }

  isAdmin() {
    let userRoles = parseJwt(this.state.token).roleList
    for (let role of userRoles) {
      if (role.code === 'ADMIN' && role.project.code === 'FB') {
        return true
      }
    }

    return false
  }

  isHead() {
    let userRoles = parseJwt(this.state.token).roleList
    for (let role of userRoles) {
      if (role.code === 'HEAD_FS' && role.project.code === 'FB') {
        return true
      }
    }

    return false
  }

  sendToAllFinOrgs(creditRequest) {
    if (
      !this.state.eurasianBankProductCode &&
      !this.state.eurasianBankInsuranceDuration
    ) {
      alert('Заполните инфо по продуктам!')
      this.setState({ openSendAllDialog: false })
      return
    }

    let self = this
    axios
      .post(
        FB_API_URL + `/finbroker/credit_request/send_to_all_fin_orgs`,
        {
          creditRequestId: creditRequest.id,
          halykCreditType: this.state.halykCreditType,
          eurasianBankProductCode: this.state.eurasianBankProductCode,
          eurasianBankInsuranceDuration:
            this.state.eurasianBankInsuranceDuration
        },
        { headers: { Authorization: `Bearer ${this.state.token}` } }
      )
      .then(function (response) {
        console.log(response)
        self.props.getCreditRequests()
        self.props.enqueueSnackbar('Кредитная заявка успешно отправлена!', {
          variant: 'success'
        })
        self.setState({
          sendCreditRequestPageNumber: 0,
          eurasianBankProductCode: null,
          eurasianBankInsuranceDuration: null,
          openSendAllDialog: false,
          isSendingToAllFinOrgs: false,
          sendAllFinOrgsButtonEnabled: true
        })
      })
      .catch(function (error) {
        console.log(error)
        self.setState({
          sendAllFinOrgsButtonEnabled: true,
          error: 'Кредитная заявка не отправлена.\n\nОшибка: ' + error
        })
      })
  }

  sendToFinOrg(finOrgName, creditRequest) {
    if (
      creditRequest.agreementFileLocation === null ||
      creditRequest.agreementFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Согласие на обработку персональных данных'
      })
    } else if (
      creditRequest.idFrontFileLocation === null ||
      creditRequest.idFrontFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Удостоверение личности (лицевая сторона)'
      })
    } else if (
      creditRequest.idBackFileLocation === null ||
      creditRequest.idBackFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Удостоверение личности (обратная сторона)'
      })
    } else if (finOrgName === 'mogo') {
      if (window.confirm('Вы готовы отправить заявку в Mogo?')) {
        this.setState({ mogoSendButtonEnabled: false })
        let self = this
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Mogo.',
              { variant: 'success' }
            )
            self.setState({
              isMogoDialogOpen: false,
              isSendingToMogo: false,
              mogoSendButtonEnabled: true
            })
          })
          .catch(function (error) {
            console.log(error)
            self.setState({
              mogoSendButtonEnabled: true,
              error:
                'Кредитная заявка не отправлена в Mogo.\n\nОшибка: ' + error
            })
          })
      }
    } else if (finOrgName === 'eurasian') {
      if (!this.state.eurasianBankProductCode) {
        alert('Выберите кредитный продукт!')
        return
      }

      if (!this.state.eurasianBankInsuranceDuration) {
        alert('Выберите период страховки!')
        return
      }

      if (window.confirm('Вы готовы отправить заявку в Евразийский Банк?')) {
        let self = this
        self.setState({ isSendingToEurasianBank: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {
              eurasianBankProductCode: self.state.eurasianBankProductCode,
              eurasianBankInsuranceDuration:
                self.state.eurasianBankInsuranceDuration
            },
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToEurasianBank: false,
              isEurasianDialogOpen: false,
              eurasianBankProductCode: '',
              eurasianBankInsuranceDuration: false
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Евразийский Банк.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToEurasianBank: false,
              isEurasianDialogOpen: false,
              error:
                'Кредитная заявка не отправлена в Евразийский Банк. \n' +
                error.response.request.data.meta
            })
          })
      }
    } else if (finOrgName === 'tfs') {
      if (window.confirm('Вы готовы отправить заявку в TFS?')) {
        let self = this
        self.setState({ isSendingToTfs: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {
              tfsProductCode: self.state.tfsProductCode
            },
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToTfs: false,
              isTfsDialogOpen: false
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в TFS.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToTfs: false,
              isTfsDialogOpen: false
            })
            this.setState({
              error:
                'Кредитная заявка не отправлена в TFS.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'forte') {
      if (window.confirm('Вы готовы отправить заявку в Forte?')) {
        let self = this
        self.setState({ isSendingToForte: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToForte: false,
              isForteDialogOpen: false
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Forte.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToForte: false,
              isForteDialogOpen: false
            })
            this.setState({
              error:
                'Кредитная заявка не отправлена в Forte.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'freedom') {
      if (window.confirm('Вы готовы отправить заявку в Freedom?')) {
        let self = this
        self.setState({ isSendingToFreedom: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToFreedom: false,
              isFreedomDialogOpen: false
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в FREEDOM.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToFreedom: false,
              isFreedomDialogOpen: false
            })
            this.setState({
              error:
                'Кредитная заявка не отправлена в Freedom.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'kmf') {
      if (window.confirm('Вы готовы отправить заявку в КМФ?')) {
        let self = this
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в КМФ.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            this.setState({
              error:
                'Кредитная заявка не отправлена в КМФ.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'shinhan') {
      if (window.confirm('Вы готовы отправить заявку в Шинхан?')) {
        let self = this
        self.setState({ isSendingToShinhan: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToShinhan: false,
              isShinhanDialogOpen: false
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Шинхан.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToShinhan: false,
              isShinhanDialogOpen: false
            })
            this.setState({
              error:
                'Кредитная заявка не отправлена в Шинхан.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'bcc') {
      if (window.confirm('Вы готовы отправить заявку в БЦК?')) {
        let self = this
        self.setState({ isSendingToBcc: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({ isSendingToBcc: false, isBccDialogOpen: false })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в БЦК.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({ isSendingToBcc: false, isBccDialogOpen: false })
            this.setState({
              error:
                'Кредитная заявка не отправлена в БЦК.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'halyk') {
      if (!creditRequest.smsOtpCode) {
        alert('Необходимо получить согласие через СМС код у клиента!')
        return
      }

      if (
        (creditRequest.carModel === 'GS5' ||
          creditRequest.carModel === 'C5' ||
          creditRequest.carModel === 'S5' ||
          creditRequest.carModel === 'Koleos') &&
        creditRequest.creditPurpose === 'Приобретение нового авто' &&
        !this.state.halykCreditType
      ) {
        alert('Необходимо выбрать тип кредита!')
        return
      }

      if (!creditRequest.carVinCode) {
        alert('Необходимо заполнить VIN код!')
        return
      }

      if (window.confirm('Вы готовы отправить заявку в Халык?')) {
        let self = this
        self.setState({ isSendingToHalyk: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {
              halykCreditType: this.state.halykCreditType
            },
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToHalyk: false,
              isHalykDialogOpen: false,
              halykCreditType: 'standard'
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Халык.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({ isSendingToHalyk: false, isHalykDialogOpen: false })
            this.setState({
              error:
                'Кредитная заявка не отправлена в Халык.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'bereke') {
      if (!this.state.ProductCode) {
        alert('Выберите продукт Береке!')
        return
      }
      if (
        this.state.IsNSInsurance === null ||
        this.state.IsNSInsurance === undefined
      ) {
        alert('Выберите страховой пакет Береке!')
        return
      }
      if (window.confirm('Вы готовы отправить заявку в Bereke Bank?')) {
        let self = this
        self.setState({ isSendingToBereke: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {
              IsNSInsurance: this.state.IsNSInsurance,
              NsCompanyCode: this.state.NsCompanyCode,
              KaskoProductCode: this.state.KaskoProductCode,
              IsInsuranceInside: this.state.IsInsuranceInside,
              ProductCode: this.state.ProductCode
            },
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToBereke: false,
              isBerekeDialogOpen: false,
              NsCompanyCode: '',
              IsInsuranceInside: false,
              KaskoProductCode: '',
              ProductCode: null,
              IsNSInsurance: null
            })
            self.props.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Bereke Bank.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToBereke: false,
              isBerekeDialogOpen: false
            })
            self.setState({
              error:
                'Кредитная заявка не отправлена в Bereke Bank.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    }
  }

  deleteCreditRequest(creditRequestId) {
    if (window.confirm('Вы готовы удалить кредитную заявку?')) {
      let self = this
      axios
        .post(
          FB_API_URL + `/finbroker/credit_request/delete/${creditRequestId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.state.token}`
            }
          }
        )
        .then(function (response) {
          self.props.getCreditRequests()
        })
        .catch(function (error) {
          console.log(error.message)
        })
    }
  }

  refreshCreditRequest(creditRequestId) {
    if (this.props.getCreditRequests !== undefined) {
      this.props.getCreditRequests()
    }
  }

  handleCapture(creditRequestId, type, event) {
    let self = this
    const formData = new FormData()
    let file = event.hasOwnProperty('target') ? event.target.files[0] : event
    formData.append('file', file)
    axios
      .post(
        FB_API_URL +
          '/finbroker/credit_request/uploadFile/' +
          type +
          '/' +
          creditRequestId,
        formData,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then(function (response) {
        console.log(response)
        if (self.props.getCreditRequests !== undefined) {
          self.props.getCreditRequests()
        } else {
        }
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  handleChange = name => event => {
    this.setState(
      {
        [name]: event.target.value
      },
      () => console.log(this.state)
    )
  }

  clearFile(creditRequestId, type) {
    if (window.confirm('Вы готовы удалить файл?')) {
      let self = this
      axios
        .post(
          FB_API_URL +
            '/finbroker/credit_request/clearFile/' +
            type +
            '/' +
            creditRequestId,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.state.token}`
            }
          }
        )
        .then(function (response) {
          console.log(response)
          self.props.getCreditRequests()
        })
        .catch(function (error) {
          console.log(error.message)
        })
    }
  }

  downloadFile(creditRequestId, type) {
    axios
      .get(
        FB_API_URL +
          '/finbroker/credit_request/downloadFile/' +
          type +
          '/' +
          creditRequestId,
        {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then(function (response) {
        console.log(response)
        let fileName = response.headers.pragma
        let fileExtension = fileName.split('.').pop()
        let blob = new Blob([response.data], {
          type: 'application/' + fileExtension
        })
        const downloadUrl = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  async duplicateCreditRequest(creditRequest) {
    if (window.confirm('Создать копию кредитной заявки?')) {
      console.log(creditRequest)
      let newCreditRequest = creditRequest

      try {
        const responseBody = await Axios.get(
          `${FB_API_URL}/finbroker/credit_request/phone/${creditRequest.id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        ).then(response => response.data)
        newCreditRequest.clientMobilePhoneNumber =
          await responseBody.clientMobilePhoneNumber
      } catch (error) {
        console.error(error)
      }

      newCreditRequest.id = null
      newCreditRequest.processed = null

      newCreditRequest.sentToEurasianBank = false
      newCreditRequest.eurasianBankSendDate = null
      newCreditRequest.eurasianStatusUpdatedDate = null
      newCreditRequest.eurasianId = null
      newCreditRequest.eurasianIsAlternative = false
      newCreditRequest.eurasianAlternativeComment = null
      newCreditRequest.approvedByEurasianBank = null
      newCreditRequest.eurasianDecisionDescription = null

      newCreditRequest.sentToMogo = false
      newCreditRequest.mogoSendDate = null
      newCreditRequest.mogoStatusUpdatedDate = null
      newCreditRequest.mogoIsAlternative = false
      newCreditRequest.mogoAlternativeComment = null
      newCreditRequest.approvedByMogo = null
      newCreditRequest.mogoDecisionDescription = null

      newCreditRequest.sentToShinhan = false
      newCreditRequest.shinhanSendDate = null
      newCreditRequest.shinhanStatusUpdatedDate = null
      newCreditRequest.shinhanIsAlternative = false
      newCreditRequest.shinhanAlternativeComment = null
      newCreditRequest.approvedByShinhan = null
      newCreditRequest.shinhanDecisionDescription = null

      newCreditRequest.sentToKmf = false
      newCreditRequest.kmfSendDate = null
      newCreditRequest.kmfStatusUpdatedDate = null
      newCreditRequest.kmfId = null
      newCreditRequest.kmfIsAlternative = false
      newCreditRequest.kmfAlternativeComment = null
      newCreditRequest.approvedByKmf = null
      newCreditRequest.kmfDecisionDescription = null

      newCreditRequest.sentToTfs = false
      newCreditRequest.tfsSendDate = null
      newCreditRequest.tfsStatusUpdatedDate = null
      newCreditRequest.tfsIsAlternative = false
      newCreditRequest.tfsAlternativeComment = null
      newCreditRequest.approvedByTfs = null
      newCreditRequest.tfsDecisionDescription = null

      newCreditRequest.sentToFreedom = false
      newCreditRequest.freedomSendDate = null
      newCreditRequest.freedomStatusUpdatedDate = null
      newCreditRequest.freedomIsAlternative = false
      newCreditRequest.freedomAlternativeComment = null
      newCreditRequest.approvedByFreedom = null
      newCreditRequest.freedomDecisionDescription = null

      newCreditRequest.sentToBereke = false
      newCreditRequest.berekeSendDate = null
      newCreditRequest.berekeStatusUpdatedDate = null
      newCreditRequest.berekeIsAlternative = false
      newCreditRequest.berekeAlternativeComment = null
      newCreditRequest.approvedByBereke = null
      newCreditRequest.berekeDecisionDescription = null

      newCreditRequest.sentToForte = false
      newCreditRequest.forteSendDate = null
      newCreditRequest.forteStatusUpdatedDate = null
      newCreditRequest.forteIsAlternative = false
      newCreditRequest.forteAlternativeComment = null
      newCreditRequest.approvedByForte = null
      newCreditRequest.forteDecisionDescription = null

      newCreditRequest.sentToHalyk = false
      newCreditRequest.halykSendDate = null
      newCreditRequest.halykStatusUpdatedDate = null
      newCreditRequest.halykDecisionDescription = null
      newCreditRequest.approvedByHalyk = null
      newCreditRequest.halykRequestId = null
      newCreditRequest.sentToHalykBy = null
      newCreditRequest.sentToHalykByName = null
      newCreditRequest.smsOtpCode = null
      newCreditRequest.agreementFileLocation = null
      newCreditRequest.halykIsAlternative = false
      newCreditRequest.halykAlternativeComment = null

      newCreditRequest.sentToBcc = false
      newCreditRequest.bccSendDate = null
      newCreditRequest.bccStatusUpdatedDate = null
      newCreditRequest.bccRequestId = null
      newCreditRequest.bccIsAlternative = false
      newCreditRequest.bccAlternativeComment = null
      newCreditRequest.bccDecisionDescription = null
      newCreditRequest.approvedByBcc = null

      newCreditRequest.createdAt = null
      console.log(creditRequest)

      let self = this
      axios
        .post(
          FB_API_URL + '/finbroker/credit_request/upsert',
          newCreditRequest,
          {
            headers: {
              Authorization: `Bearer ${this.state.token}`
            }
          }
        )
        .then(function (response) {
          console.log(response.data)
          self.props.enqueueSnackbar(
            'Кредитная заявка успешно продублирована!',
            { variant: 'success' }
          )
          self.props.getCreditRequests()
        })
        .catch(function (error) {
          console.log(error.message)
        })
    }
  }

  processCreditRequest(decision) {
    let self = this
    axios
      .post(
        FB_API_URL + '/finbroker/credit_request/process',
        {
          decision: decision,
          bank: this.state.selectedBank,
          creditRequestId: this.props.creditRequest.id
        },
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`
          }
        }
      )
      .then(function (response) {
        console.log(response.data)
        self.props.enqueueSnackbar('Кредитная заявка обновлена!', {
          variant: 'success'
        })
        self.setState({
          isProcessCreditRequestOpen: false
        })
        self.props.getCreditRequests()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  saveAlternative() {
    let self = this
    axios
      .post(
        FB_API_URL + '/finbroker/credit_request/set_alternative',
        {
          finOrgName: this.state.selectedBank,
          creditRequestId: this.props.creditRequest.id,
          alternativeComment: this.state.alternativeComment
        },
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`
          }
        }
      )
      .then(function (response) {
        console.log(response.data)
        self.props.enqueueSnackbar('Статус альтернатива сохранен!', {
          variant: 'success'
        })
        self.setState({
          isAlternativeDialogOpen: false,
          alternativeComment: null
        })
        self.props.getCreditRequests()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }
  handleOpenPhoto = () => {
    this.setState(
      {
        openPhoto: !this.state.openPhoto
      },
      () => {}
    )
  }

  handleOpenBankDialog = bank => {
    const creditRequest = this.props.creditRequest

    if (bank === 'Mogo') {
      this.sendToFinOrg(bank.toLowerCase(), creditRequest)
      return
    }

    if (bank === 'Freedom') {
      this.sendToFinOrg(bank.toLowerCase(), creditRequest)
      return
    }

    if (bank === 'Forte') {
      this.sendToFinOrg(bank.toLowerCase(), creditRequest)
      return
    }

    this.setState({
      [`is${bank}DialogOpen`]: true,
      selectedCreditRequest: creditRequest
    })
  }

  sendOtpCode(creditRequest) {
    if (
      window.confirm(
        'Вы готовы отправить SMS код клиенту?\nНа номер ' +
          creditRequest.clientMobilePhoneNumber +
          ' будет отправлен код по SMS.\n' +
          'Проверьтре корректность номера телефона!'
      )
    ) {
      let self = this
      axios
        .post(
          FB_API_URL +
            `/finbroker/credit_request/send_otp_code/${creditRequest.id}`,
          {},
          { headers: { Authorization: `Bearer ${this.state.token}` } }
        )
        .then(function (response) {
          console.log(response.data)
          self.props.enqueueSnackbar('Код подтверждения отправлен клиенту!', {
            variant: 'success'
          })
          self.setState({ isOtpDialogOpen: true })
        })
        .catch(function (error) {
          console.log(error.message)
          self.props.enqueueSnackbar('Код не отправлен!', { variant: 'error' })
        })
    }
  }

  checkOtpCode(creditRequest) {
    let self = this
    axios
      .post(
        FB_API_URL +
          '/finbroker/credit_request/check_otp_code/' +
          creditRequest.id +
          '/' +
          this.state.clientOtpCode,
        {},
        { headers: { Authorization: `Bearer ${this.state.token}` } }
      )
      .then(function (response) {
        console.log(response.data)
        self.setState({ isOtpDialogOpen: false, clientOtpCode: '' })
        self.props.enqueueSnackbar('Код подтвержден!', { variant: 'success' })
        self.props.getCreditRequests()
      })
      .catch(function (error) {
        console.log(error.message)
        self.props.enqueueSnackbar('Некорректный код!', { variant: 'error' })
      })
  }

  render() {
    if (!this.props.creditRequest) {
      return null
    }

    let creditRequest = this.props.creditRequest

    const banks = [
      {
        primary: 'EurasianBank',
        label: 'Евразийский Банк',
        secondary: 'eurasian'
      },
      {
        primary: 'Mogo',
        label: 'Мого'
      },
      {
        primary: 'Kmf',
        label: 'KMF'
      },
      {
        primary: 'Shinhan',
        label: 'Shinhan'
      },
      {
        primary: 'Bcc',
        label: 'БЦК'
      },
      {
        primary: 'Halyk',
        label: 'Халык'
      },
      {
        primary: 'Bereke',
        label: 'Bereke'
      },
      {
        primary: 'Tfs',
        label: 'TFS'
      },
      {
        primary: 'Forte',
        label: 'Forte'
      },
      {
        primary: 'Freedom',
        label: 'Freedom'
      }
    ]

    return (
      <div style={{ marginTop: '10px' }}>
        <div style={{ textAlign: 'left', margin: 'auto' }}>
          <Paper key={creditRequest.id} className="paper-nohover">
            <div className="item_head">
              <div>
                <span
                  className="link"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '26px',
                    color: '#3a3a3a',
                    cursor: 'pointer',
                    marginRight: '10px'
                  }}
                  onClick={() =>
                    this.setState({
                      selectedCreditRequest: creditRequest,
                      crView: true
                    })
                  }
                >
                  {creditRequest.clientFirstname} {creditRequest.clientLastname}
                </span>
                <Tooltip title="Дублировать">
                  <IconButton
                    size="small"
                    style={{ marginRight: '10px' }}
                    color="primary"
                    onClick={this.duplicateCreditRequest.bind(
                      this,
                      creditRequest
                    )}
                  >
                    <FileCopyIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                {!creditRequest.sentToKmf &&
                  !creditRequest.sentToEurasianBank &&
                  !creditRequest.sentToMogo &&
                  !creditRequest.sentToShinhan &&
                  !creditRequest.sentToTfs &&
                  !creditRequest.sentToForte &&
                  !creditRequest.sentToFreedom &&
                  !creditRequest.sentToBcc &&
                  !creditRequest.sentToHalyk &&
                  !creditRequest.sentToBereke && (
                    <Tooltip title="Редактировать">
                      <IconButton
                        size="small"
                        style={{ marginRight: '10px' }}
                        color="primary"
                        onClick={() =>
                          this.setState({
                            selectedCreditRequest: creditRequest,
                            crEdit: true
                          })
                        }
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                {!creditRequest.sentToKmf &&
                  !creditRequest.sentToEurasianBank &&
                  !creditRequest.sentToMogo &&
                  !creditRequest.sentToShinhan &&
                  !creditRequest.sentToTfs &&
                  !creditRequest.sentToForte &&
                  !creditRequest.sentToFreedom &&
                  !creditRequest.sentToBcc &&
                  !creditRequest.sentToHalyk &&
                  !creditRequest.sentToBereke && (
                    <Tooltip title="Удалить">
                      <IconButton
                        size="small"
                        style={{ marginRight: '10px' }}
                        color="secondary"
                        onClick={this.deleteCreditRequest.bind(
                          this,
                          creditRequest.id
                        )}
                      >
                        <DeleteForeverIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                <Tooltip title="Обновить">
                  <IconButton
                    size="small"
                    style={{ marginRight: '10px' }}
                    color="primary"
                    onClick={this.refreshCreditRequest.bind(
                      this,
                      creditRequest.id
                    )}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                {!creditRequest.agreementFileLocation && (
                  <Button
                    onClick={this.sendOtpCode.bind(this, creditRequest)}
                    className="button_green_color button_small"
                  >
                    Получить согласие
                  </Button>
                )}
              </div>
              <div
                style={{ fontSize: '17px', color: '#555', fontWeight: 'bold' }}
              >
                <span style={{ marginRight: '5px' }}>
                  {creditRequest.clientIIN}
                </span>
                <Chip
                  label={getCityNameByCode(creditRequest.branchCode)}
                  size="small"
                  style={{
                    color: '#FFF',
                    backgroundColor: '#666',
                    fontWeight: 400
                  }}
                />
                {(creditRequest.creditPurpose === 'Приобретение нового авто' ||
                  creditRequest.creditPurpose === 'Приобретение БУ авто') && (
                  <Chip
                    size="small"
                    style={{ marginLeft: '5px' }}
                    label={
                      creditRequest.creditPurpose === 'Приобретение нового авто'
                        ? 'ОПА'
                        : creditRequest.creditPurpose === 'Приобретение БУ авто'
                        ? 'АМП'
                        : null
                    }
                  />
                )}
              </div>
              <div style={{ fontSize: '14px' }}>
                {moment(creditRequest.createdAt).format('DD.MM.YYYY HH:mm')}
              </div>
              <div style={{ fontSize: '14px' }}>ID: {creditRequest.id}</div>
              <div style={{ fontSize: '14px' }}>
                РЛ:{' '}
                {creditRequest.saleGlobalId ||
                  creditRequest.saleIdNew ||
                  'Без РЛ'}
              </div>
              <div style={{ fontSize: '14px' }}>
                Менеджер ФС: {creditRequest.createdByFullName}
              </div>
            </div>

            <div className="requestPaper">
              <div
                className={
                  creditRequest.agreementFileLocation !== null &&
                  creditRequest.agreementFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.agreementFileLocation !== null &&
                  creditRequest.agreementFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">
                  Согласие на обработку
                  <br />
                  персональных данных
                </div>
                <div className="requestButtons">
                  {
                    creditRequest.agreementFileLocation !== null &&
                      creditRequest.agreementFileLocation !== undefined && (
                        <React.Fragment>
                          {/*{!creditRequest.sentToKmf &&*/}
                          {/*  !creditRequest.sentToEurasianBank &&*/}
                          {/*  !creditRequest.sentToMogo &&*/}
                          {/*  !creditRequest.sentToShinhan &&*/}
                          {/*  !creditRequest.sentToTfs &&*/}
                          {/*  !creditRequest.sentToForte &&*/}
                          {/*  !creditRequest.sentToFreedom &&*/}
                          {/*  !creditRequest.sentToBcc &&*/}
                          {/*  !creditRequest.sentToHalyk &&*/}
                          {/*  !creditRequest.smsOtpCode &&*/}
                          {/*  !creditRequest.sentToBereke && (*/}
                          {/*    <IconButton*/}
                          {/*      size="medium"*/}
                          {/*      color="secondary"*/}
                          {/*      onClick={this.clearFile.bind(*/}
                          {/*        this,*/}
                          {/*        creditRequest.id,*/}
                          {/*        'agreement'*/}
                          {/*      )}*/}
                          {/*      title="Удалить"*/}
                          {/*    >*/}
                          {/*      <DeleteIcon />*/}
                          {/*    </IconButton>*/}
                          {/*  )}*/}
                          <IconButton
                            size="medium"
                            style={{ color: '#0089d0' }}
                            onClick={this.downloadFile.bind(
                              this,
                              creditRequest.id,
                              'agreement'
                            )}
                            title="Скачать"
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        </React.Fragment>
                      )
                    // : (
                    //   <IconButton
                    //     size="medium"
                    //     title="Загрузить"
                    //     component="label"
                    //     style={{ color: '#0089d0' }}
                    //   >
                    //     <CloudUploadIcon />
                    //     <input
                    //       type="file"
                    //       accept="image/png, image/jpeg"
                    //       onChange={this.handleCapture.bind(
                    //         this,
                    //         creditRequest.id,
                    //         'agreement'
                    //       )}
                    //       style={{ display: 'none' }}
                    //     />
                    //   </IconButton>
                  }
                </div>
              </div>

              <div
                className={
                  creditRequest.idFrontFileLocation !== null &&
                  creditRequest.idFrontFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.idFrontFileLocation !== null &&
                  creditRequest.idFrontFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">
                  Удостоверение личности
                  <br />
                  (лицевая сторона)
                </div>
                <div className="requestButtons">
                  {creditRequest.idFrontFileLocation !== null &&
                  creditRequest.idFrontFileLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'idFront'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'idFront'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <IconButton
                      size="medium"
                      title="Загрузить"
                      component="label"
                      style={{ color: '#0089d0' }}
                    >
                      <CloudUploadIcon />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={this.handleCapture.bind(
                          this,
                          creditRequest.id,
                          'idFront'
                        )}
                        style={{ display: 'none' }}
                      />
                    </IconButton>
                  )}
                </div>
              </div>

              <div
                className={
                  creditRequest.idBackFileLocation !== null &&
                  creditRequest.idBackFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.idBackFileLocation !== null &&
                  creditRequest.idBackFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">
                  Удостоверение личности
                  <br />
                  (обратная сторона)
                </div>
                <div className="requestButtons">
                  {creditRequest.idBackFileLocation !== null &&
                  creditRequest.idBackFileLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'idBack'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'idBack'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <IconButton
                      size="medium"
                      title="Загрузить"
                      component="label"
                      style={{ color: '#0089d0' }}
                    >
                      <CloudUploadIcon />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={this.handleCapture.bind(
                          this,
                          creditRequest.id,
                          'idBack'
                        )}
                        style={{ display: 'none' }}
                      />
                    </IconButton>
                  )}
                </div>
              </div>
              <div
                className={
                  creditRequest.clientPhotoLocation !== null &&
                  creditRequest.clientPhotoLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.clientPhotoLocation !== null &&
                  creditRequest.clientPhotoLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">Фотография клиента</div>
                <div className="requestButtons">
                  {creditRequest.clientPhotoLocation !== null &&
                  creditRequest.clientPhotoLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'clientPhoto'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'clientPhoto'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <div style={{ display: 'flex', gap: 10 }}>
                      <IconButton
                        size="medium"
                        title="Загрузить"
                        component="label"
                        style={{ color: '#0089d0' }}
                        onClick={this.handleOpenPhoto}
                      >
                        <PhotoCamera />
                      </IconButton>
                      <IconButton
                        size="medium"
                        title="Загрузить"
                        component="label"
                        style={{ color: '#0089d0' }}
                      >
                        <CloudUploadIcon />
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={this.handleCapture.bind(
                            this,
                            creditRequest.id,
                            'clientPhoto'
                          )}
                          style={{ display: 'none' }}
                        />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={
                  creditRequest.bankStatementFileLocation !== null &&
                  creditRequest.bankStatementFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.bankStatementFileLocation !== null &&
                  creditRequest.bankStatementFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">Выписка банка</div>
                <div className="requestButtons">
                  {creditRequest.bankStatementFileLocation !== null &&
                  creditRequest.bankStatementFileLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'bankStatement'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'bankStatement'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <IconButton
                      size="medium"
                      title="Загрузить"
                      component="label"
                      style={{ color: '#0089d0' }}
                    >
                      <CloudUploadIcon />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={this.handleCapture.bind(
                          this,
                          creditRequest.id,
                          'bankStatement'
                        )}
                        style={{ display: 'none' }}
                      />
                    </IconButton>
                  )}
                </div>
              </div>

              <div
                className={
                  creditRequest.bankStatementQrFileLocation !== null &&
                  creditRequest.bankStatementQrFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.bankStatementQrFileLocation !== null &&
                  creditRequest.bankStatementQrFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">Выписка банка с QR</div>
                <div className="requestButtons">
                  {creditRequest.bankStatementQrFileLocation !== null &&
                  creditRequest.bankStatementQrFileLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'bankStatementQr'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'bankStatementQr'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <IconButton
                      size="medium"
                      title="Загрузить"
                      component="label"
                      style={{ color: '#0089d0' }}
                    >
                      <CloudUploadIcon />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={this.handleCapture.bind(
                          this,
                          creditRequest.id,
                          'bankStatementQr'
                        )}
                        style={{ display: 'none' }}
                      />
                    </IconButton>
                  )}
                </div>
              </div>

              <div
                className={
                  creditRequest.incomeStatementFileLocation !== null &&
                  creditRequest.incomeStatementFileLocation !== undefined
                    ? 'requestLine requestLineBG_ok'
                    : 'requestLine requestLineBG_nofile'
                }
              >
                <div className="requestStatusIcon">
                  {creditRequest.incomeStatementFileLocation !== null &&
                  creditRequest.incomeStatementFileLocation !== undefined ? (
                    <DoneIcon className="successColor" />
                  ) : (
                    <RemoveCircleOutlineIcon className="errorColor" />
                  )}
                </div>
                <div className="requestText">Справка о доходах</div>
                <div className="requestButtons">
                  {creditRequest.incomeStatementFileLocation !== null &&
                  creditRequest.incomeStatementFileLocation !== undefined ? (
                    <React.Fragment>
                      {!creditRequest.sentToKmf &&
                        !creditRequest.sentToEurasianBank &&
                        !creditRequest.sentToMogo &&
                        !creditRequest.sentToShinhan &&
                        !creditRequest.sentToTfs &&
                        !creditRequest.sentToForte &&
                        !creditRequest.sentToFreedom &&
                        !creditRequest.sentToBcc &&
                        !creditRequest.sentToHalyk &&
                        !creditRequest.sentToBereke && (
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={this.clearFile.bind(
                              this,
                              creditRequest.id,
                              'incomeStatement'
                            )}
                            title="Удалить"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        size="medium"
                        style={{ color: '#0089d0' }}
                        onClick={this.downloadFile.bind(
                          this,
                          creditRequest.id,
                          'incomeStatement'
                        )}
                        title="Скачать"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </React.Fragment>
                  ) : (
                    <IconButton
                      size="medium"
                      title="Загрузить"
                      component="label"
                      style={{ color: '#0089d0' }}
                    >
                      <CloudUploadIcon />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={this.handleCapture.bind(
                          this,
                          creditRequest.id,
                          'incomeStatement'
                        )}
                        style={{ display: 'none' }}
                      />
                    </IconButton>
                  )}
                </div>
              </div>
            </div>

            <div className="item_foot">
              {(creditRequest.sentToEurasianBank ||
                creditRequest.sentToMogo ||
                creditRequest.sentToKmf ||
                creditRequest.sentToTfs ||
                creditRequest.sentToForte ||
                creditRequest.sentToFreedom ||
                creditRequest.sentToShinhan ||
                creditRequest.sentToBcc ||
                creditRequest.sentToHalyk ||
                creditRequest.sentToBereke) && (
                <div>
                  {banks?.map(bank => (
                    <CreditRequestButton
                      self={this}
                      label={bank.label}
                      bank={bank}
                      creditRequest={creditRequest}
                      downloadFile={this.downloadFile}
                    />
                  ))}
                </div>
              )}

              {this.isHead() &&
                (!creditRequest.sentToKmf ||
                  !creditRequest.sentToEurasianBank ||
                  !creditRequest.sentToMogo ||
                  !creditRequest.sentToShinhan ||
                  !creditRequest.sentToTfs ||
                  !creditRequest.sentToForte ||
                  !creditRequest.sentToFreedom ||
                  !creditRequest.sentToBcc ||
                  !creditRequest.sentToHalyk ||
                  !creditRequest.sentToBereke) && (
                  <div>
                    <div
                      style={{
                        marginTop: '15px',
                        fontWeight: '400',
                        marginBottom: '5px'
                      }}
                    >
                      Отправить в:
                    </div>
                    {!creditRequest.sentToEurasianBank && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Eurasian')}
                      >
                        Евраз
                      </Button>
                    )}
                    {!creditRequest.sentToMogo && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        disabled={!this.state.mogoSendButtonEnabled}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Mogo')}
                      >
                        Мого
                      </Button>
                    )}
                    {!creditRequest.sentToKmf && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('KMF')}
                      >
                        КМФ
                      </Button>
                    )}
                    {!creditRequest.sentToTfs && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Tfs')}
                      >
                        TFS
                      </Button>
                    )}
                    {!creditRequest.sentToForte && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Forte')}
                      >
                        Forte
                      </Button>
                    )}
                    {!creditRequest.sentToFreedom && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Freedom')}
                      >
                        Freedom
                      </Button>
                    )}
                    {!creditRequest.sentToShinhan && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Shinhan')}
                      >
                        Шинхан
                      </Button>
                    )}
                    {!creditRequest.sentToBcc && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Bcc')}
                      >
                        БЦК
                      </Button>
                    )}
                    {!creditRequest.sentToHalyk && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Halyk')}
                      >
                        Халык
                      </Button>
                    )}
                    {!creditRequest.sentToBereke && (
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        style={{ marginBottom: '5px' }}
                        className="button_small button_regular_color"
                        onClick={() => this.handleOpenBankDialog('Bereke')}
                      >
                        Bereke
                      </Button>
                    )}
                  </div>
                )}

              {!this.isHead() && creditRequest.processed == null && (
                <Button
                  style={{ paddingTop: '10px' }}
                  size="small"
                  color="primary"
                  variant="outlined"
                  className="button_small button_regular_color"
                  onClick={() => {
                    if (!creditRequest.agreementFileLocation) {
                      alert('Получите согласие клиента!')
                      return
                    }

                    this.setState({
                      openSendAllDialog: true,
                      selectedCreditRequest: this.props.creditRequest
                    })
                  }}
                >
                  Отправить заявку
                </Button>
              )}
            </div>
          </Paper>
        </div>

        <Dialog
          onClose={() => {
            this.setState({ isProcessCreditRequestOpen: false })
          }}
          open={this.state.isProcessCreditRequestOpen}
          keepMounted
        >
          <DialogTitle>Статус заявки</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                className="button_small button_green_color"
                onClick={this.processCreditRequest.bind(this, 'approved')}
              >
                Одобрить
              </Button>
              <Button
                className="button_small button_red_color"
                onClick={this.processCreditRequest.bind(this, 'declined')}
              >
                Отказать
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isAlternativeDialogOpen: false })
          }}
          open={this.state.isAlternativeDialogOpen}
          keepMounted
        >
          <DialogTitle>Альтернатива</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={this.state.alternativeComment}
                  onChange={this.handleChange('alternativeComment')}
                >
                  <FormControlLabel
                    value="Увеличение ПВ"
                    control={<Radio />}
                    label="Увеличение ПВ"
                  />
                  <FormControlLabel
                    value="Изменение срока"
                    control={<Radio />}
                    label="Изменение срока"
                  />
                  <FormControlLabel
                    value="Изменение срока и ПВ"
                    control={<Radio />}
                    label="Изменение срока и ПВ"
                  />
                  <FormControlLabel
                    value="Наличие гаранта"
                    control={<Radio />}
                    label="Наличие гаранта"
                  />
                  <FormControlLabel
                    value="Другое"
                    control={<Radio />}
                    label="Другое"
                  />
                  <Button
                    style={{ marginTop: '20px' }}
                    className="button_small button_green_color"
                    onClick={this.saveAlternative.bind(this, 'declined')}
                  >
                    Сохранить
                  </Button>
                  <Button
                    style={{ marginTop: '10px' }}
                    className="button_small button_grey_color"
                    onClick={() =>
                      this.setState({ isAlternativeDialogOpen: false })
                    }
                  >
                    Закрыть
                  </Button>
                </RadioGroup>
              </FormControl>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isEurasianDialogOpen: false })
          }}
          open={this.state.isEurasianDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Евразийский Банк</DialogTitle>
          <DialogContent>
            <div style={{ paddingTop: '10px' }}>
              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel htmlFor="city">Продукт</InputLabel>
                <Select
                  value={this.state.eurasianBankProductCode}
                  className="textfield_green"
                  onChange={this.handleChange('eurasianBankProductCode')}
                  input={<OutlinedInput labelWidth={60} />}
                >
                  <MenuItem value={'4'}>Евраз 4</MenuItem>
                  <MenuItem value={'5'}>Евраз 5</MenuItem>
                  <MenuItem value={'6'}>Евраз 6</MenuItem>
                  {/*<MenuItem value={'44'}>Евраз 4,4</MenuItem>*/}
                  {/*<MenuItem value={'0'}>Рассрочка</MenuItem>*/}
                </Select>
              </FormControl>
            </div>
            <div style={{ paddingTop: '10px' }}>
              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel htmlFor="city">Период страховки</InputLabel>
                <Select
                  value={this.state.eurasianBankInsuranceDuration}
                  className="textfield_green"
                  onChange={this.handleChange('eurasianBankInsuranceDuration')}
                  input={<OutlinedInput labelWidth={130} />}
                >
                  <MenuItem value={1}>1 год</MenuItem>
                  <MenuItem value={2}>2 года</MenuItem>
                  <MenuItem value={3}>3 года</MenuItem>
                  <MenuItem value={4}>4 года</MenuItem>
                  <MenuItem value={5}>5 лет</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToEurasianBank}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'eurasian',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isEurasianDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isTfsDialogOpen: false })
          }}
          open={this.state.isTfsDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в TFS</DialogTitle>
          <DialogContent>
            <div style={{ paddingTop: '10px' }}>
              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel htmlFor="city">Продукт</InputLabel>
                <Select
                  value={this.state.tfsProductCode}
                  className="textfield_green"
                  onChange={this.handleChange('tfsProductCode')}
                  input={<OutlinedInput labelWidth={60} />}
                >
                  <MenuItem value={'Продукт 1'}>Продукт 1</MenuItem>
                  <MenuItem value={'Продукт 2'}>Продукт 2</MenuItem>
                  <MenuItem value={'Продукт 3'}>Продукт 3</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToTfs}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'tfs',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              &nbsp;
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isTfsDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isBerekeDialogOpen: false })
          }}
          open={this.state.isBerekeDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Bereke Bank</DialogTitle>
          <DialogContent>
            <div style={{ paddingTop: '10px' }}>
              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel htmlFor="city">Продукт</InputLabel>
                <Select
                  value={this.state.ProductCode}
                  className="textfield_green"
                  onChange={this.handleChange('ProductCode')}
                  input={<OutlinedInput labelWidth={60} />}
                >
                  <MenuItem value={'auto-008-carfin-aster1'}>
                    БУ Автокредит - 1
                  </MenuItem>
                  <MenuItem value={'auto-009-carfin-aster2'}>
                    БУ Автокредит - 2
                  </MenuItem>
                  <MenuItem value={'auto-007-carfin-standart'}>
                    Новые авто Автокредит
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={{ paddingTop: '10px' }}>
              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel htmlFor="city">Страховой пакет</InputLabel>
                <Select
                  value={this.state.IsNSInsurance}
                  className="textfield_green"
                  onChange={this.handleChange('IsNSInsurance')}
                  input={<OutlinedInput labelWidth={130} />}
                >
                  <MenuItem value={true}>НС стандарт</MenuItem>
                  <MenuItem value={false}>Без страховки</MenuItem>
                </Select>
              </FormControl>
            </div>
            {this.state.IsNSInsurance && (
              <div style={{ paddingTop: '10px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Страховая компания</InputLabel>
                  <Select
                    value={this.state.NsCompanyCode}
                    className="textfield_green"
                    onChange={this.handleChange('NsCompanyCode')}
                    input={<OutlinedInput labelWidth={165} />}
                  >
                    <MenuItem value={'001'}>NOMAD LIFE</MenuItem>
                    <MenuItem value={'006'}>Европейская СК</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
            {this.state.IsNSInsurance && (
              <div style={{ paddingTop: '10px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Страховка включена?</InputLabel>
                  <Select
                    value={this.state.IsInsuranceInside}
                    className="textfield_green"
                    onChange={this.handleChange('IsInsuranceInside')}
                    input={<OutlinedInput labelWidth={170} />}
                  >
                    <MenuItem value={true}>Да</MenuItem>
                    <MenuItem value={false}>Нет</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
            {this.state.IsNSInsurance && (
              <div style={{ paddingTop: '10px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">КАСКО</InputLabel>
                  <Select
                    value={this.state.KaskoProductCode}
                    className="textfield_green"
                    onChange={this.handleChange('KaskoProductCode')}
                    input={<OutlinedInput labelWidth={50} />}
                  >
                    <MenuItem value={'105'}>тариф Премиум</MenuItem>
                    <MenuItem value={'106'}>тариф Премиум+</MenuItem>
                    <MenuItem value={''}>Без КАСКО</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToBereke}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'bereke',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isBerekeDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isShinhanDialogOpen: false })
          }}
          open={this.state.isShinhanDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Шинхан</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToShinhan}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'shinhan',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isShinhanDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isBccDialogOpen: false })
          }}
          open={this.state.isBccDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в БЦК</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToBcc}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'bcc',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isBccDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isKMFDialogOpen: false })
          }}
          open={this.state.isKMFDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в КМФ</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToKMF}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'kmf',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isKMFDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isHalykDialogOpen: false })
          }}
          open={this.state.isHalykDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Халык</DialogTitle>
          <DialogContent>
            <div style={{ paddingBottom: '15px' }}>
              {(creditRequest.carModel === 'GS5' ||
                creditRequest.carModel === 'C5' ||
                creditRequest.carModel === 'S5' ||
                creditRequest.carModel === 'Koleos') &&
                creditRequest.creditPurpose === 'Приобретение нового авто' && (
                  <FormControl variant="outlined" fullWidth={true}>
                    <InputLabel htmlFor="city">Тип кредита</InputLabel>
                    <Select
                      value={this.state.halykCreditType}
                      className="textfield_green"
                      onChange={this.handleChange('halykCreditType')}
                      input={<OutlinedInput labelWidth={130} />}
                    >
                      <MenuItem value={'standard'}>Стандартный</MenuItem>
                      {/*<MenuItem value={'subsidy'}>Субсидированный</MenuItem>*/}
                    </Select>
                  </FormControl>
                )}
            </div>

            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToHalyk}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'halyk',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isHalykDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={() => {
            this.setState({ isMogoDialogOpen: false })
          }}
          open={this.state.isMogoDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Mogo</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToMogo}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'mogo',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isMogoDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
          message="Заявка обновлена"
          action={
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        />

        {this.state.selectedCreditRequest && (
          <Dialog
            open={this.state.crView}
            fullScreen
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => this.setState({ crView: null })}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">
                  Кредитная заявка (просмотр)
                </Typography>
              </Toolbar>
            </AppBar>
            <div style={{ marginTop: '80px' }}>
              <ViewCreditRequest
                creditRequest={this.state.selectedCreditRequest}
                sentToKmf={creditRequest.sentToKmf}
              />
            </div>
          </Dialog>
        )}

        {this.state.selectedCreditRequest && (
          <Dialog
            open={this.state.crEdit}
            fullScreen
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => this.setState({ crEdit: false })}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">
                  Кредитная заявка (редактирование)
                </Typography>
              </Toolbar>
            </AppBar>
            <div style={{ marginTop: '80px' }}>
              <EditCreditRequest
                sale={this.props.sale}
                closeDialog={() => {
                  this.setState({ crEdit: false })
                  this.props.getCreditRequests()
                }}
                creditRequestId={this.state.selectedCreditRequest.id}
              />
            </div>
          </Dialog>
        )}

        <Dialog
          open={this.state.isOtpDialogOpen}
          onClose={() => this.setState({ isOtpDialogOpen: false })}
        >
          <DialogTitle>Подтвердить согласие</DialogTitle>
          <div style={{ marginTop: '10px' }}>
            <div>
              <TextField
                autoFocus={true}
                value={this.state.clientOtpCode}
                InputProps={{ className: 'textfield_green' }}
                fullWidth={true}
                variant="outlined"
                label="OTP код"
                onChange={this.handleChange('clientOtpCode')}
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                onClick={this.checkOtpCode.bind(this, creditRequest)}
                className="button_green_color button_small"
              >
                Проверить код
              </Button>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.openSendAllDialog}
          onClose={() =>
            this.setState({
              openSendAllDialog: false,
              sendCreditRequestPageNumber: 0,
              eurasianBankProductCode: null,
              eurasianBankInsuranceDuration: null,
              halykCreditType: 'standard'
            })
          }
        >
          <DialogTitle>Отправить заявку</DialogTitle>
          {this.state.sendCreditRequestPageNumber == 0 && (
            <div style={{ marginTop: '10px' }}>
              <div style={{ paddingTop: '10px' }}>Eвразийский Банк</div>
              <div style={{ paddingTop: '20px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Продукт</InputLabel>
                  <Select
                    value={this.state.eurasianBankProductCode}
                    className="textfield_green"
                    onChange={this.handleChange('eurasianBankProductCode')}
                    input={<OutlinedInput labelWidth={60} />}
                  >
                    <MenuItem value={'4'}>Евраз 4</MenuItem>
                    {creditRequest.simplifiedFin === 'Да' && (
                      <MenuItem value={'44'}>Евраз 4.4</MenuItem>
                    )}
                    <MenuItem value={'5'}>Евраз 5</MenuItem>
                    <MenuItem value={'6'}>Евраз 6</MenuItem>
                    {/*<MenuItem value={'0'}>Рассрочка</MenuItem>*/}
                  </Select>
                </FormControl>
              </div>
              <div style={{ paddingTop: '10px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Период страховки</InputLabel>
                  <Select
                    value={this.state.eurasianBankInsuranceDuration}
                    className="textfield_green"
                    onChange={this.handleChange(
                      'eurasianBankInsuranceDuration'
                    )}
                    input={<OutlinedInput labelWidth={130} />}
                  >
                    <MenuItem value={1}>1 год</MenuItem>
                    <MenuItem value={2}>2 года</MenuItem>
                    <MenuItem value={3}>3 года</MenuItem>
                    <MenuItem value={4}>4 года</MenuItem>
                    <MenuItem value={5}>5 лет</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={{ marginTop: '10px' }}>
                <Button
                  onClick={() =>
                    this.setState({
                      sendCreditRequestPageNumber:
                        this.state.sendCreditRequestPageNumber + 1
                    })
                  }
                  className="button_green_color button_small"
                >
                  Далее
                </Button>
              </div>
            </div>
          )}

          {this.state.sendCreditRequestPageNumber == 1 && (
            <div style={{ marginTop: '10px' }}>
              <div style={{ marginTop: '10px' }}>Халык Банк</div>
              <div style={{ paddingBottom: '20px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Тип кредита</InputLabel>
                  <Select
                    value={this.state.halykCreditType}
                    className="textfield_green"
                    onChange={this.handleChange('halykCreditType')}
                    input={<OutlinedInput labelWidth={130} />}
                  >
                    <MenuItem value={'standard'}>Стандартный</MenuItem>
                    {/*{(creditRequest.carModel === 'GS5' ||*/}
                    {/*  creditRequest.carModel === 'C5' ||*/}
                    {/*  creditRequest.carModel === 'S5' ||*/}
                    {/*  creditRequest.carModel === 'Koleos') &&*/}
                    {/*  creditRequest.creditPurpose ===*/}
                    {/*    'Приобретение нового авто' && (*/}
                    {/*    <MenuItem value={'subsidy'}>Субсидированный</MenuItem>*/}
                    {/*  )}*/}
                  </Select>
                </FormControl>
              </div>
              <div style={{ marginTop: '10px' }}>
                <Button
                  onClick={() =>
                    this.setState({
                      sendCreditRequestPageNumber:
                        this.state.sendCreditRequestPageNumber + 1
                    })
                  }
                  className="button_green_color button_small"
                >
                  Далее
                </Button>
              </div>
            </div>
          )}

          {this.state.sendCreditRequestPageNumber == 2 && (
            <div style={{ marginTop: '10px' }}>
              <div style={{ marginTop: '10px' }}>TFS</div>
              <div style={{ paddingTop: '10px' }}>
                <FormControl variant="outlined" fullWidth={true}>
                  <InputLabel htmlFor="city">Продукт</InputLabel>
                  <Select
                    value={this.state.tfsProductCode}
                    className="textfield_green"
                    onChange={this.handleChange('tfsProductCode')}
                    input={<OutlinedInput labelWidth={60} />}
                  >
                    <MenuItem value={'Продукт 1'}>Продукт 1</MenuItem>
                    <MenuItem value={'Продукт 2'}>Продукт 2</MenuItem>
                    <MenuItem value={'Продукт 3'}>Продукт 3</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={{ marginTop: '10px' }}>
                <Button
                  onClick={() =>
                    this.setState({
                      sendCreditRequestPageNumber:
                        this.state.sendCreditRequestPageNumber + 1
                    })
                  }
                  className="button_green_color button_small"
                >
                  Далее
                </Button>
              </div>
            </div>
          )}

          {this.state.sendCreditRequestPageNumber == 3 && (
            <div style={{ marginTop: '10px' }}>
              <div style={{ marginTop: '10px' }}>
                <Button
                  disabled={this.state.isSendingToBcc}
                  className="button_small button_green_color"
                  onClick={this.sendToAllFinOrgs.bind(
                    this,
                    this.state.selectedCreditRequest
                  )}
                >
                  Отправить
                </Button>
                <Button
                  className="button_small button_grey_color"
                  onClick={() => this.setState({ isBccDialogOpen: false })}
                >
                  Закрыть
                </Button>
              </div>
            </div>
          )}
        </Dialog>

        {this.state.openPhoto && (
          <PhotoModal
            open={this.state.openPhoto}
            onClose={this.handleOpenPhoto}
            loadFile={this.handleCapture.bind(
              this,
              creditRequest.id,
              'clientPhoto'
            )}
          />
        )}
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

export default flowRight(withSnackbar)(CreditRequest)

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})
